import { ANALYTICS_STATUS, ANALYTICS_TRIAL_API_ACCESS, UPDATE_ANALYTICS_STATUS } from '../keys'
const initialState = {
    analytics: false,
    webAnalytic: false,
    trialAccessAPI: false,
    analyticsWallID: 0,
    isEnableButton: true,
    duplicatePostId: 0
}
export default function reducer(state = initialState, action) {
    switch (action.type) {
        
        case ANALYTICS_STATUS: {
            let { analytics, webAnalytic, id, pid, isDowngrade, duplicatePostId } = action.payload;
            let trialAccessAPI = analytics && webAnalytic ? false : true;

            var isEnableButtonVisible = false;
            if (pid && pid.length > 0) {
                pid.map((item) => {
                    if (["31", "32", "52", "54", "55", "61"].includes(item) && !isEnableButtonVisible) {
                        isEnableButtonVisible = true;
                    }
                })
            }

            if (isDowngrade && isDowngrade != "" && Object.keys(isDowngrade).length > 0) {
                if ([31, 32, 52, 54, 55, 61].includes(isDowngrade.planId) && !isEnableButtonVisible) {
                    isEnableButtonVisible = true;
                }
            }
        
            return { ...state, analytics, webAnalytic, trialAccessAPI, analyticsWallID: id, isEnableButton: isEnableButtonVisible, duplicatePostId }
        }
        case ANALYTICS_TRIAL_API_ACCESS: {
            return { ...state, trialAccessAPI: action.payload }
        }
        case UPDATE_ANALYTICS_STATUS: {
            return { ...state, analytics: action.payload }
        }
        default:
            return { ...state }
    }

}